import { Line }   from "../../planner_base";
import watch from "redux-watch";
import isEqual from 'is-equal';
class Schedules extends Line {
  init(){
    super.init();
    this.watch();
  }
  onChangeStore(a,b,c){
    this.opts.schedules = null; // 一度cellを消すため
    this.update();
    super.onChangeStore(a, b, c);
  }
}
riot.mixin('orders.planner.line-ui.schedules', Schedules as riot.TagMixin)
